module.exports = __webpack_public_path__ + "media/images/lb/860-d5883579b04fb77d08d2466ed476ff53.svg";